module.exports = __webpack_public_path__ + "img/weltenburg_fraeuenberg_2020_ref.7d37d625.jpg";